import React from "react";
import { PageShell } from "../components/PageShell";
export function History() {
  return <PageShell title="L'histoire du premier vol" intro="25 juin 1978 : Jean-Claude Bétemps et André Bohn décollent du Pertuiset et inventent le parapente." data-id="element-184" data-mp="9p64vryq3fwh" />;
}